export default "__VITE_PUBLIC_ASSET__0fe1de0b__"